import { Pipe, PipeTransform, NgModule } from '@angular/core';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
type AnyArray = any[];

@Pipe({ name: 'toArray', standalone: false })
export class ToArrayPipe implements PipeTransform {
  /**
   * Converts an object to an array of its values
   * @param input - The object to convert
   * @returns Array of object values
   */
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  transform(input: any): AnyArray {
    if (input == null || typeof input !== 'object') {
      return input;
    }
    return Object.keys(input).map((key) => input[key]);
  }
}

@NgModule({
  declarations: [ToArrayPipe],
  exports: [ToArrayPipe],
})
export class NgToArrayPipeModule {}
